import { useState } from "react"
import WorkPlaceAnalysisWrapper from "../components/WorkPlaceAnalysisWrapper"
import TimesheetContent from "./component/TimesheetContent"
import ShiftSwapSection from "./component/ShiftSwapSection"
import CustomBreadCrumb from "./component/CustomBreadCrumb"

const ReportingWorkplace = () => {
  const [selectedTimeLine, setSelectedTimeLine] = useState("3d")
  const [modal, setModal] = useState({
    timesheetSection: true,
    shiftSwapSection: false,
  })

  // ─── Render ───────────────────────────────────────────────────────────────

  return (
    <div>
      {modal.shiftSwapSection && (
        <CustomBreadCrumb
          onClick={() =>
            setModal(() => ({
              timesheetSection: true,
              shiftSwapSection: false,
            }))
          }
          prefixName="Reporting"
          suffixName="Shift Swap Requests"
        />
      )}
      {modal.shiftSwapSection ? (
        <ShiftSwapSection />
      ) : (
        <div className="flex flex-col gap-4">
          <WorkPlaceAnalysisWrapper
            title="High-level stats"
            timeline={selectedTimeLine}
            setSelectedTimeline={(value) => setSelectedTimeLine(value)}
          />

          <TimesheetContent
            onClick={() => {
              setModal(() => ({
                timesheetSection: false,
                shiftSwapSection: true,
              }))
            }}
          />
        </div>
      )}
    </div>
  )
}

export default ReportingWorkplace
